import { __assign } from "tslib";
import * as React from 'react';
import WeeklyCalendarFunc from './WeeklyCalendarFunc';
import WeeklyDesktopTodayBorder from '../../presentationals/WeeklyDesktopTodayBorder';
import WeeklyBorderBottom from '../../presentationals/WeeklyBorderBottom';
import { StyleWrapperComponent } from './WeeklyWrapper.styles';
import WixStylesContext from '../../../context/wixStylesContext';
import WeeklyContext from '../../../context/weeklyContext';
import { classes } from './WeeklyCalendar.st.css';
var WeeklyCalendarStyled = function () {
    var _a = React.useContext(WixStylesContext), eventTitleFontSize = _a.eventTitleFontSize, eventTimeFontSize = _a.eventTimeFontSize, eventTitleFont = _a.eventTitleFont, calendarBackgroundColorWithoutOpacity = _a.calendarBackgroundColorWithoutOpacity, cellBorderColor = _a.cellBorderColor, cellBorderWidth = _a.cellBorderWidth, isResponsive = _a.isResponsive;
    var date = React.useContext(WeeklyContext).date;
    var _b = React.useState(true), isTodayBorder = _b[0], setIsTodayBorder = _b[1];
    React.useEffect(function () {
        if (document.getElementsByClassName('fc-day-today').length > 0) {
            setIsTodayBorder(true);
        }
        else {
            setIsTodayBorder(false);
        }
    }, [date]);
    var dafaultEventFontHight = 14;
    var timegridSlotHeight = 50 + cellBorderWidth * 2;
    var eventMainMinHeight = 11 + 4; //22;
    if (eventTitleFontSize >= dafaultEventFontHight ||
        eventTimeFontSize >= dafaultEventFontHight) {
        var heightDiff = eventTitleFontSize + eventTimeFontSize - dafaultEventFontHight * 2;
        eventMainMinHeight += heightDiff;
        timegridSlotHeight = timegridSlotHeight + heightDiff;
    }
    var eventPadding = '2px 1px 0px 1px';
    var fcTimegridColPaddingRight = '0';
    var fcTimegridColPaddingLeft = '0';
    var todayPaddingTimegrid = '0 1px 0 1px';
    var todayPaddingDaygrid = '1px 1px 0 1px';
    if (cellBorderWidth === 2) {
        eventPadding = '2px 1px 1px 0';
        fcTimegridColPaddingRight = '0';
        fcTimegridColPaddingLeft = '1px';
        todayPaddingTimegrid = '0 2px 0 3px';
        todayPaddingDaygrid = '1px 2px 0 2px';
    }
    if (cellBorderWidth === 3) {
        eventPadding = '3px 1px 1px 0';
        fcTimegridColPaddingRight = '0';
        fcTimegridColPaddingLeft = '1px';
        todayPaddingTimegrid = '0 3px 0 4px';
        todayPaddingDaygrid = '2px 3px 0 3px';
    }
    var styledProps = {
        eventTitleFont: eventTitleFont,
        calendarBackgroundColor: calendarBackgroundColorWithoutOpacity,
        cellBorderColor: cellBorderColor,
        cellBorderWidth: cellBorderWidth,
        timegridSlotHeight: timegridSlotHeight,
        eventMainMinHeight: eventMainMinHeight,
        eventPadding: eventPadding,
        todayPaddingTimegrid: todayPaddingTimegrid,
        todayPaddingDaygrid: todayPaddingDaygrid,
        fcTimegridColPaddingRight: fcTimegridColPaddingRight,
        fcTimegridColPaddingLeft: fcTimegridColPaddingLeft,
        isResponsive: isResponsive,
    };
    React.useEffect(function () {
        var removeElementsByClass = function (className, position) {
            document.getElementsByClassName(className)[position].remove();
        };
        removeElementsByClass('fc-scrollgrid-section', 1);
    }, []);
    return (React.createElement(React.Fragment, null,
        isTodayBorder && React.createElement(WeeklyDesktopTodayBorder, null),
        React.createElement(WeeklyBorderBottom, { styledProps: styledProps }),
        React.createElement(StyleWrapperComponent, __assign({}, styledProps),
            React.createElement(WeeklyCalendarFunc, null)),
        !isResponsive && (React.createElement("div", { id: "prefixedBottomPadding", className: classes.PrefixedBottom }))));
};
export default WeeklyCalendarStyled;
//# sourceMappingURL=WeeklyCalendarStyled.js.map